import * as faker from 'faker'
import moment from 'moment'

import merchants from 'utility/merchants'

const makeDeposit = (options = {}) => {
  let transaction = {
    id: options.id || `tr-deposit`,
    label: 'Mobile Deposit',
    icon: require('icons/check-deposit.svg'),
    amount: options.amount || faker.commerce.price(),
    date: faker.date.between(
      moment().toDate(),
      moment().subtract(1, 'month').toDate()
    ),
    isCredit: true,
    pending: false
  }
  return transaction
}

const makeTransactions = (options = {}) => {
  const { num } = options
  let transactions = []

  for (let i = 0; i < (num || 32); ++i) {
    const merchant = faker.random.arrayElement(merchants)
    const range = merchant.range

    const amount = faker.finance.amount(range.min, range.max, 2)

    if (!options.hasDeposits || i < 30) {
      transactions.push({
        id: `tr-${i + 1}`,
        label: merchant.name,
        logo: merchant.logo,
        amount: amount || faker.commerce.price(),
        date: faker.date.between(
          moment().toDate(),
          moment().subtract(1, 'month').toDate()
        ),
        pending: false
      })
    } else {
      transactions.push(
        makeDeposit({
          id: `tr-${i + 1}`
        })
      )
    }
  }

  transactions.sort((a, b) => b.date - a.date)

  if (transactions.length > 2) {
    transactions[0].pending = true
    transactions[1].pending = true
  }

  return transactions
}

const generateMonthlyPayments = (options = {}) => {
  const { num, amount } = options
  let transactions = []

  for (let i = 0; i < (num || 10); ++i) {
    transactions.push({
      id: `tr-${i + 1}`,
      label: 'Recurring Monthly Payment',
      amount: amount || faker.commerce.price(),
      date: moment().startOf('month').subtract(i, 'months').toDate(),
      pending: false,
      icon: require('icons/transfer.svg')
    })
  }

  transactions.sort((a, b) => a.date < b.date)

  return transactions
}

export { makeTransactions, generateMonthlyPayments }
